import { render, staticRenderFns } from "./testDetail.vue?vue&type=template&id=2b75aadb&scoped=true&"
import script from "./testDetail.vue?vue&type=script&lang=js&"
export * from "./testDetail.vue?vue&type=script&lang=js&"
import style0 from "./testDetail.vue?vue&type=style&index=0&id=2b75aadb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b75aadb",
  null
  
)

export default component.exports